export function multiply<T>(agg: T[][], items: T[]): T[][] {
    if (agg.length === 0) {
        return items.map((i) => [i]);
    }

    const result: T[][] = [];

    for (const item of agg) {
        for (const item2 of items) {
            result.push([...item, item2]);
        }
    }

    return result;
}
